import "@/index.css";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/i18n";
import { AuthProvider } from "@/context/AuthContext";
import HomePage from "@/pages/HomePage";
import ProGate from "@/pages/ProGate";
import AdminGate from "@/pages/AdminGate";
import LegalPage from "@/pages/LegalPage";
import ResetPage from "@/pages/ResetPage";

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/espace-pro" element={<ProGate />} />
            <Route path="/admin" element={<AdminGate />} />
            <Route path="/confidentialite" element={<LegalPage />} />
            <Route path="/reinitialiser" element={<ResetPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
